<template>
  <div id="the-identification-overlay" :style="`width: ${hoveredFeature?.type ? '' : '300px'}`">
    <template v-if="hoveredFeature?.type === 'offer'">
      <div class="overlay-name text-body-2 font-weight-medium pb-1">{{ name }}</div>
      <div style="min-height: 50px" v-if="image">
        <img :src="image" style="width: 280px" />
      </div>
      <div v-else style="background-color: rgba(0, 0, 0, 0.1)" class="d-flex justify-center align-center py-16">
        <v-icon color="#fff">mdi-note-remove-outline</v-icon>
      </div>
    </template>
    <template v-else-if="hoveredFeature?.type">
      <div class="overlay-name text-body-2 font-weight-medium pb-1">{{ name }}</div>
      <div class="overlay-count text-body-2 font-weight-medium secondary--text pb-1">
        {{ `${$i18n.t('sidebar.offersCount')} ${count}` }}
      </div>
      <div class="overlay-footer text-body-2 font-lighten-2--text">{{ $i18n.t('sidebar.clickToSeeOffer') }}</div>
    </template>
  </div>
</template>
<script>
import { get } from 'vuex-pathify';
export default {
  name: 'TheMapOverlay',
  props: {
    hoveredFeature: {
      type: Object,
    },
  },
  computed: {
    dataSources: get('featuresData/dataSources'),
    layers: get('featuresData/layers'),
    projectLayersGeojsons: get('featuresData/projectLayersGeojsons'),
    offersCount: get('featuresData/offersCount'),
    currentLayer() {
      return this.hoveredFeature?.layerId;
    },
    count() {
      return (
        this.offersCount[this.$i18n.locale]?.[this.hoveredFeature?.type]?.[this.hoveredFeature?.id]?.['count'] || 0
      );
    },
    name() {
      if (!this.hoveredFeature) return '';
      const attr = this.dataSources[this.layers[this.currentLayer]?.dataSourceName]?.descriptionAttributeName;
      const feature = this.projectLayersGeojsons[this.currentLayer]?.features.find(
        feature => feature.id === this.hoveredFeature?.id
      );
      if (this.hoveredFeature.type === 'offer') {
        return feature?.properties[attr] || feature?.properties['nazwa'];
      } else {
        return `${this.$i18n.t(`default.${this.hoveredFeature?.type}`)} ${
          feature?.properties[attr] || feature?.properties['jpt_nazwa']
        }`;
      }
    },
    image() {
      if (!this.hoveredFeature) return '';
      const attr = this.layers[this.currentLayer]?.imageAttribute;
      const feature = this.projectLayersGeojsons[this.currentLayer]?.features.find(
        feature => feature.id === this.hoveredFeature?.id
      );
      const attrValue = feature?.properties[attr] || '';
      return attrValue?.startsWith('/') ? `${process.env.VUE_APP_API_URL}${attrValue}` : attrValue;
    },
  },
};
</script>
<style lang="scss" scoped>
#the-identification-overlay {
  padding: 10px;
  background-color: white;
}
.overlay-name {
  font-size: 16px !important;
}
.overlay-count {
  font-size: 14px !important;
  color: orange;
}
.overlay-footer {
  font-size: 11px !important;
  font-weight: 300;
  font-style: italic;
}
</style>
